import React, { useState } from "react";
import moment from "moment/moment";
import { Button, Modal } from "antd";
import OrderConfirmationModel from "./OrderConfirmationModel";
import OrderSuccessUpdateModel from "./OrderSuccessUpdateModel";
import { Link } from "react-router-dom";

const SingleOrderPendingCard = () => {
  const [cnfloading, setCnfLoading] = useState(false);
  const [cnfopen, setCnfOpen] = useState(false);
  const [successopen, setSuccessOpen] = useState(false);
  const [spinning, setSpinning] = useState(false);
  const date = new Date();

  const showCnfModal = () => {
    setCnfOpen(true);
  };
  const handleCnfOk = () => {
    setCnfLoading(true);
    setTimeout(() => {
      setCnfLoading(false);
      setCnfOpen(false);
    }, 3000);
  };
  const handleCnfCancel = (value) => {
    setCnfOpen(value);
  };
  const handleSuccessCancel = () => {
    setSuccessOpen(false);
  };

  const showLoader = async () => {
    setSpinning(true);
    setTimeout(async () => {
      setCnfOpen(false);
      setSpinning(false);
      setSuccessOpen(true);
    }, 3000);
  };

  return (
    <>
      <Modal
        open={cnfopen}
        title=""
        onOk={handleCnfOk}
        onCancel={() => handleCnfCancel(false)}
        maskClosable={false}
        closable={false}
        style={{
          top: 20,
        }}
        footer={[
          <Button
            className="confirm_btn btn_apt"
            loading={cnfloading}
            onClick={showLoader}
          >
            Countinue With Default
          </Button>,
        ]}
      >
        <OrderConfirmationModel
          handleCnfCancel={handleCnfCancel}
          showLoader={showLoader}
          spinning={spinning}
        />
      </Modal>
      <Modal
        open={successopen}
        title=""
        onCancel={() => setSuccessOpen(false)}
        maskClosable={false}
        closable={false}
        style={{
          top: 20,
        }}
        width={400}
        footer={null}
      >
        <OrderSuccessUpdateModel handleSuccessCancel={handleSuccessCancel} />
      </Modal>
      <div className="single_order_box">
        <div className="single_order_box_space">
          <div className="order_box_top">
            <div className="order_box_hedaer">
              <div className="ord_b_hd_left">
                <h5>
                  ORDER ID -{" "}
                  <span
                    style={{
                      color: "#3c9daa",
                      fontWeight: "800",
                      fontSize: "0.85rem",
                      textTransform: "uppercase",
                    }}
                  >
                    752
                  </span>
                </h5>
              </div>
              <div className="ord_b_hd_right">
                <h5>
                  ORDER DATE -{" "}
                  <span
                    style={{
                      color: "#333333",
                      fontWeight: "700",
                      fontSize: "0.85rem",
                    }}
                  >
                    {moment(date).format("DD MMM YYYY,h:mm A")}
                  </span>
                </h5>
              </div>
            </div>
            <div className="ord_item_detail">
              <Link to="/admin/order-info">
                <div className="item_container_ds">
                  <div className="ds_order_img_b">
                    <img src="/assets/logo/logo.jpg" alt="logo" />
                  </div>
                  <h5 style={{ cursor: "pointer" }}>
                    Tocipapas X 7
                    <span
                      style={{
                        color: "#333333",
                        fontWeight: "700",
                        fontSize: "0.85rem",
                        paddingLeft: "1vh",
                      }}
                    >
                      more
                    </span>
                  </h5>
                </div>
              </Link>
            </div>
            <div className="ord_payment_detail">
              <h5>
                Payment -{" "}
                <span
                  style={{
                    color: "#333333",
                    fontWeight: "700",
                    fontSize: "0.85rem",
                  }}
                >
                  Online
                </span>
              </h5>
            </div>
          </div>
          <div className="order_box_bottom">
            <div className="ord_b_bottom_left">
              <div className="addree_container">
                <h5>
                  Order Price -
                  <span
                    style={{
                      color: "#333333",
                      fontWeight: "700",
                      fontSize: "0.85rem",
                      paddingLeft: "1vh",
                    }}
                  >
                    218.00
                  </span>
                </h5>
                <h5>
                  <span
                    style={{
                      color: "#595959",
                      fontWeight: "700",
                      fontSize: "0.85rem",
                    }}
                    className="line_clamp"
                  >
                    Dexterous Technology, Flat No - 3, First Floor, Sharada
                    Complex, Plot No - 103, Vengal Rao Nagar Rd, Kalyan Nagar
                    Phase 1, Siddarth Nagar, Ameerpet, Hyderabad, Telangana
                    500038
                  </span>
                </h5>
              </div>
            </div>
            <div className="ord_b_bottom_right">
              <Button
                className="reject_btn"
                onClick={() => setSuccessOpen(true)}
              >
                Reject
              </Button>
              <Button className="confirm_btn" onClick={showCnfModal}>
                Confirm
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SingleOrderPendingCard;
